import * as React from 'react';
import * as echarts from 'echarts'
import CommonUtils from '@/utils/commonUtils';
import 'echarts-wordcloud';
// var echarts = require('echarts');
class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      word_cloud: [], // 具体要显示的内容
    };
  }
  UNSAFE_componentWillMount() {
    // console.log('this.props.word_cloud', this.props.word_cloud);
    if (this.props.word_cloud) {
      this.setState({ word_cloud: this.props.word_cloud }, () => {
        this.renderEcharsWordCloud();
      });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('nextProps: ', nextProps);
    if (nextProps && nextProps.word_cloud && nextProps.word_cloud.length > 0) {
      this.setState({ word_cloud: nextProps.word_cloud }, () => {
        this.renderEcharsWordCloud();
      });
    }

  }
  renderEcharsWordCloud = () => {
    let originData = this.state.word_cloud;
    // 格式化数据
    const data = originData.map(val => ({
      ...val,
      textStyle: {
        color: CommonUtils.randomColor(),
      }
    }));
    // console.log('data格式化后: ', data);
    var chart = echarts.init(document.getElementById('word-chart'));
    chart.setOption({
      backgroundColor: '#F7F7F7',
      series: [{
        type: 'wordCloud',
        shape: 'diamond',
        left: 'center',
        top: 'center',
        right: 'center',
        bottom: 'center',
        width: '70%',
        height: '80%',
        sizeRange: [12, 60],
        rotationRange: [0, 0],
        rotationStep: 45,
        gridSize: 8,
        drawOutOfBound: false,
        textStyle: {
          emphasis: {
            focus: 'self',
            shadowBlur: 10,
            shadowColor: '#FF6A00'
          }
        },
        data
      }]
    });
  }
  render() {
    return (
      <React.Fragment>
        {
          this.state.word_cloud &&
          <React.Fragment>
            <div className="word-chart" id="word-chart" />
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default Summary;